import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home.vue'
import Product from '../components/Product/Product.vue'
import Cases from '../components/Cases.vue'
import About from '../components/About/About.vue'
import Infomation from '../components/Infomation.vue'
import Made from '../components/Made.vue'
import Wanwu from '../components/Product/Wanwu.vue'
import Robot from '../components/Product/Robot.vue'
import Brief from '../components/About/Brief.vue'
import Events from '../components/About/Events.vue'
import Honour from '../components/About/Honour.vue'
import Contact from '../components/About/Contact.vue'
import CasesDetail from '../components/Cases_detail_1.vue'
import InformationDetail1 from '../components/Information_detail_1.vue'
//移动端组件
import Home_m from '../mobile/Home-m.vue'
import Wanwu_m from '../mobile/Wanwu-m.vue'
import Robot_m from '../mobile/Robot-m.vue'
import Cases_m from '../mobile/Cases-m.vue'
import Brief_m from '../mobile/About/Brief-m.vue'
import Memory_m from '../mobile/About/Memory-m.vue'
import Honour_m from '../mobile/Honour-m.vue'
import Contact_m from '../mobile/Contact-m.vue'
import Info_m from '../mobile/Info-m.vue'
import Made_m from '../mobile/Made-m.vue'
import Cases_detail_m from '../mobile/Cases_detail.vue'


Vue.use(VueRouter)
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}
const routes = [
  //电脑端路由
  { path: '/', redirect: '/home', },
  { path: '/home', component: () => import('../components/Home.vue') },

  {
    path: '/product', component: () => import('../components/Product/Product.vue'), redirect: '/product/wanwu',
    children: [
      { path: '/product/wanwu', component: () => import('../components/Product/Wanwu.vue') },
      { path: '/product/robot', component: () => import('../components/Product/Robot.vue') }
    ]
  },
  { path: '/cases', component: () => import('../components/Cases.vue') },
  {
    path: '/about', component: () => import('../components/About/About.vue'), redirect: '/about/brief',
    children: [
      { path: '/about/brief', component: () => import('../components/About/Brief.vue') },
      { path: '/about/events', component: () => import('../components/About/Events.vue') },
      { path: '/about/honour', component: () => import('../components/About/Honour.vue') },
      { path: '/about/contact', component: () => import('../components/About/Contact.vue') }

    ]
  },
  { path: '/infomation', component: () => import('../components/Infomation.vue') },
  { path: '/made', component: () => import('../components/Made.vue'), },
  { path: '/casesDetail', component: () => import('../components/Cases_detail_1.vue'), },
  { path: '/InformationDetail1', component: () => import('../components/Information_detail_1.vue'), },
  //手机端路由
  { path: '/home-m', component: () => import('../mobile/Home-m.vue'), },
  { path: '/wanwu-m', component: () => import('../mobile/Wanwu-m.vue') },
  { path: '/robot-m', component: () => import('../mobile/Robot-m.vue'), },
  { path: '/cases-m', component: () => import('../mobile/Cases-m.vue'), },
  { path: '/brief-m', component: () => import('../mobile/About/Brief-m.vue'), },
  { path: '/memory-m', component: () => import('../mobile/About/Memory-m.vue') },
  { path: '/honour-m', component: () => import('../mobile/Honour-m.vue') },
  { path: '/contact-m', component: () => import('../mobile/Contact-m.vue') },
  { path: '/info-m', component: () => import('../mobile/Info-m.vue') },
  { path: '/made-m', component: () => import('../mobile/Made-m.vue'), },
  { path: '/cases_detail-m', component: () => import('../mobile/Cases_detail.vue'), },
]


const router = new VueRouter({
  routes
})

export default router
